<script lang="ts">
  import { createEventDispatcher } from "svelte";

  export let decision = "";
  export let trigger = "";

  const dispatch = createEventDispatcher();

  $: decisionLine = (decision || "").trim() || "You have not said the decision yet.";
  $: triggerLine = (trigger || "").trim() || "You have not said what put this on the desk.";

  function go(dir: string) {
    dispatch("navigate", { dir, answer: "" });
  }
</script>

<div class="readback">
  <p class="eyebrow">Have I got this?</p>
  <h2 class="heading">This is what you said. Not the brief.</h2>
  <p class="lede">I'm reading your words back. If this is wrong, go back before I write.</p>

  <figure class="quote">
    <figcaption>The decision</figcaption>
    <blockquote>{decisionLine}</blockquote>
  </figure>

  <figure class="quote">
    <figcaption>Why it's on the desk</figcaption>
    <blockquote>{triggerLine}</blockquote>
  </figure>

  <p class="note">The brief is only as sharp as this.</p>

  <div class="actions">
    <button type="button" class="ghost" on:click={() => go("adjust")}>
      Let me adjust
    </button>
    <button type="button" class="primary" on:click={() => go("next")}>
      That's right
    </button>
  </div>
</div>

<style>
  .readback {
    display: flex;
    flex-direction: column;
    gap: var(--space-4);
  }

  .eyebrow {
    margin: 0;
    font-size: var(--text-sm);
    font-weight: 500;
    color: var(--primary);
    letter-spacing: 0.02em;
  }

  .heading {
    margin: 0;
    font-size: var(--text-xl);
    font-weight: 500;
    color: var(--grey);
    line-height: 1.35;
    text-align: left;
  }

  .lede,
  .note {
    margin: 0;
    color: var(--grey-secondary);
    font-size: var(--text-base);
    line-height: 1.5;
    text-align: left;
    font-weight: 300;
  }

  .quote {
    margin: 0;
    padding: var(--space-3) var(--space-4);
    background: var(--surface-sunken);
    border-radius: var(--radius-card);
    border-left: 3px solid var(--primary);
    text-align: left;
  }

  .quote figcaption {
    margin: 0 0 var(--space-2);
    font-size: var(--text-xs);
    font-weight: 500;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--grey-secondary);
  }

  .quote blockquote {
    margin: 0;
    font-size: var(--text-base);
    font-weight: 300;
    line-height: 1.55;
    color: var(--grey);
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }

  .actions {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-3);
    margin-top: var(--space-2);
  }

  .ghost,
  .primary {
    border: 0;
    cursor: pointer;
    border-radius: var(--radius-cta);
    padding: 0.75rem 1.1rem;
    font-weight: 500;
    font-size: var(--text-sm);
  }

  .ghost {
    background: transparent;
    color: var(--grey);
    box-shadow: inset 0 0 0 1px var(--border-color);
  }

  .primary {
    background: var(--primary);
    color: var(--color-bright);
    box-shadow: var(--shadow-cta);
  }

  .ghost:focus-visible,
  .primary:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }
</style>
